module.exports = __webpack_public_path__ + "static/media/onecredible_logo.b76feef9.jpg";